<template>
  <section>
    <h2> 多項式 f(x), g(x) を入力 </h2>
    <ul>
      <li> f(x) の次数 : <input type="number" :class="{error: f_error}" v-model.number="deg_f" /> 次 </li>
      <li> g(x) の次数 : <input type="number" :class="{error: g_error}" v-model.number="deg_g" /> 次 </li>
    </ul>
    <p>係数として入力できるのは有理数のみです。文字式や無理数、虚数は扱えません。分数は「-1/2」のように入力して下さい。</p>
    <div class="math">
      f(x) <span class="equal"> =  </span>
      <span v-for="(item,i) in ar_f" :key="'f-' + i">
	<span v-if="i != 0" class="plus"> + </span>
	<input type="text" :class="{error: item.error || (i == 0 && item.frac.equals(zero))}" v-model="item.input"/>
	<span v-if="i != ar_f.length-1">
	  x
	  <sup v-if="i != ar_f.length-2">{{ar_f.length - i -1}}</sup>
	</span>
      </span>
    </div>
    <div class="math">
      g(x) <span class="equal"> =  </span>
      <span v-for="(item,i) in ar_g" :key="'g-' + i">
	<span v-if="i != 0" class="plus"> + </span>
	<input type="text" :class="{error: item.error || (i == 0 && item.frac.equals(zero))}" v-model="item.input"/>
	<span v-if="i != ar_g.length-1">
	  x
	  <sup v-if="i != ar_g.length-2">{{ar_g.length - i -1}}</sup>
	</span>
      </span>
    </div>
    <p v-if="! error">
      <button class="exec" @click="set">決定</button>
    </p>
  </section>
</template>

<script>
import { zero, InputField, Polynominal } from '@/lib/poly.js';

export default {
  name: 'InputPolynominal',
  props: {
    f: Polynominal,
    g: Polynominal    
  },
  data: function(){
    return {
      deg_f: 3,
      deg_g: 2,
      ar_f: [],
      ar_g: [],
      zero: zero
    }
  },
  computed: {
    f_error(){
      return this.deg_f < 0 || ! Number.isInteger(this.deg_f)
    },
    g_error(){
      return this.deg_g < 0 || ! Number.isInteger(this.deg_g)
    },
    error(){
      return this.f_error || this.g_error || this.ar_f.some( e => e.error) || this.ar_g.some( e => e.error) ||
	this.ar_f.length == 0 || this.ar_g.length == 0 || this.ar_f[0].frac.equals(zero) || this.ar_g[0].frac.equals(zero);
    }
  },
  created: function(){
    this.ar_f.push(new InputField('1'));
    for(let i=1; i<=this.deg_f;i++){
      this.ar_f.push(new InputField('0'));
    }
    this.ar_g.push(new InputField('1'));
    for(let i=1; i<=this.deg_g;i++){
      this.ar_g.push(new InputField('0'));
    }
  },
  methods: {
    setAr(ar,deg){
      if(deg <ar.length - 1){
	ar.splice(deg+1);
      }else{
	while(deg > ar.length -1){
	  ar.unshift( new InputField('0') );
	}
      }
    },
    set(){
      this.f.input(this.ar_f);
      this.g.input(this.ar_g);
      this.$emit('finish');
    }
  },
  watch: {
    deg_f: function(){
      if(! this.f_error){
	this.setAr(this.ar_f,this.deg_f);
      }
    },
    deg_g: function(){
      if(! this.g_error){
	this.setAr(this.ar_g,this.deg_g);
      }
    },
  }
}
</script>

<style scoped>
</style>
